var map = {
	"./1_down@2x.png": 974,
	"./1_up@2x.png": 975,
	"./2_down@2x.png": 976,
	"./2_up@2x.png": 977,
	"./3_down@2x.png": 978,
	"./3_up@2x.png": 979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4477;